import { useEffect } from 'react';

/** The browser tab's title while a page is shown; the title it had before comes back when the page goes
 *  (otherwise a lab's name stayed on the tab after leaving its page). No title (still loading): unchanged. */
export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    const before = document.title;
    document.title = title;
    return () => { document.title = before; };
  }, [title]);
}

export default useDocumentTitle;
